import { type } from '@ngrx/signals';
import {event, eventGroup} from '@ngrx/signals/events';
import {
  AnswerData,
  EngagementData, EntityListData,
  Filter,
  Network, PaginatedData,
  PeriodData, Poi,
  RatingTrendData,
  StarsData
} from '@models/online-reputation.models';

export type NetworkFilterKey = keyof Pick<Network, 'brands' | 'dealers' | 'outlets' | 'agents'>;

export type PeriodPreset =
  | 'free'
  | 'current_month'
  | '3_months'
  | '6_months'
  | '12_months'
  | 'quarter_to_date'
  | 'semester_to_date'
  | 'year_to_date'
  | 'last_year_month'
  | 'last_year_quarter';

export type PeriodFilterValue = {
  periodType: PeriodPreset;
  currentFrom?: Date;
  currentTo?: Date;
  previousFrom?: Date;
  previousTo?: Date;
};

export const applyFilter = event(
  '[Filter] Filter change',
  type<Filter>(),
);

export const toggleFilterDrawer = event(
  '[Filter] Toggle filter drawer',
);

export const clearAllFilters = event(
  '[Filter] Clear all filters',
);

export const clearFilter = event(
  '[Filter] Clear filter',
  type<{ key: NetworkFilterKey }>(),
);

export const clearPeriodFilter = event(
  '[Filter] Clear period filter',
);

export const filterApiEvents = eventGroup({
  source: 'Filter API',
  events: {
    loadLocationsSuccess: type<PaginatedData<EntityListData>>(),
  },
});

